import React from 'react'
import { Text } from 'react-native'
import useActiveMinutesCountdown from 'APP/Hooks/useActiveMinutesCountdown'
import { Challenge } from '@dialogue/services/dist/active-minutes/model'

const Countdown = ({ challenge }: { challenge: Challenge }) => {
  const countdown = useActiveMinutesCountdown(challenge)

  return <Text>{countdown}</Text>
}

export default Countdown
